/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delivery_Fulfillment_CarrierInputs */

const vi_delivery_fulfillment_carrier = /** @type {(inputs: Delivery_Fulfillment_CarrierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hãng vận chuyển`)
};

/**

* @param {Delivery_Fulfillment_CarrierInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const delivery_fulfillment_carrier = /** @type {((inputs?: Delivery_Fulfillment_CarrierInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delivery_Fulfillment_CarrierInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_delivery_fulfillment_carrier(inputs)
});